import { useLayoutEffect } from 'react';
import { useGetProfileQuery } from 'redux/api/user.api';
import { useNavigate } from 'react-router-dom';
import { urls } from 'shared/constants/routing.constants';
import { LOCAL_STORAGE } from 'shared/constants/local-storage-constants';

export const useAuth = () => {
  const { data = null, isLoading, error } = useGetProfileQuery();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    const token = localStorage.getItem(LOCAL_STORAGE.token);
    const refresh = localStorage.getItem(LOCAL_STORAGE.refreshToken);

    if (!isLoading && (error || (!data && !token && !refresh))) {
      localStorage.removeItem(LOCAL_STORAGE.token);
      localStorage.removeItem(LOCAL_STORAGE.refreshToken);
      navigate(urls.commonPages.home);
    }
  }, [data, navigate, isLoading, error]);
};
